import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import bgImage from "../../assets/backgroung.jpg";
import "./fonts";

const stripHtml = (html) => {
  if (!html) return "";

  return html
    // Convert common HTML entities
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")

    // Preserve line breaks
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<\/div>/gi, "\n")
    .replace(/<\/li>/gi, "\n")

    // Add bullet for list items
    .replace(/<li[^>]*>/gi, "• ")

    // Remove remaining HTML tags
    .replace(/<[^>]+>/g, "")

    // Decode remaining numeric entities
    .replace(/&#(\d+);/g, (_, dec) =>
      String.fromCharCode(dec)
    )
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) =>
      String.fromCharCode(parseInt(hex, 16))
    )

    // Clean whitespace
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n[ \t]+/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};

const parseListItems = (html) => {
  if (!html) return [];

  html = html
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/<br\s*\/?>/gi, "\n");

  const liMatches = html.match(/<li[^>]*>(.*?)<\/li>/gis);

  if (liMatches && liMatches.length > 0) {
    return liMatches.map((item) =>
      item
        .replace(/<li[^>]*>/gi, "")
        .replace(/<\/li>/gi, "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/&nbsp;/gi, " ")
        .replace(/<[^>]+>/g, "")
        .trim(),
    );
  }

  return html
    .replace(/<\/p>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .split("\n")
    .map((t) => t.trim())
    .filter(Boolean);
};
const getMeals = (meals) => {
  if (!meals) return [];
  return Object.entries(meals)
    .filter(([_, val]) => val === true)
    .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1));
};

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    padding: 28,
  },

  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: 595,
    height: 842,
    opacity: 0.7,
  },

  header: {
    backgroundColor: "#D4AF37",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 6,
    borderRadius: 6,
    marginBottom: 12,
  },

  logo: { width: "auto", height: 40 },

  contact: { fontSize: 9, color: "#1e2a44", textAlign: "right" },

  packageCard: {
    backgroundColor: "#ffffff",
    borderRadius: 10,
    padding: 6,
    border: "1px solid #eee",
    marginBottom: 8,
  },

  packageTitle: {
    fontSize: 22,
    fontWeight: "bold",
    textAlign: "center",
    color: "#D4AF37",
    fontFamily: "Cormorant",
  },
  priceHighlight: {
    backgroundColor: "#d4af37",
    padding: 6,
    borderRadius: 5,
  },

  duration: { fontSize: 12, textAlign: "center", marginTop: 4 },

  sectionCard: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    padding: 6,
    borderWidth: 1,
    borderColor: "#D4AF37",
    marginBottom: 8,
  },

  sectionHeader: {
    backgroundColor: "#D4AF37",
    padding: 6,
    borderRadius: 4,
    marginBottom: 8,
  },
  timeRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 2,
  },

  sectionTitle: {
    color: "#1e2a44",
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "Cormorant",
  },
  text: {
    fontFamily: "Lato",
    fontSize: 10,
    lineHeight: 1.5,
  },

  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#ddd",
  },

  tableRow: {
    flexDirection: "row",
  },

  tableHeader: {
    backgroundColor: "#D4AF37",
  },

  tableCol: {
    width: "25%",
    borderRightWidth: 1,
    borderColor: "#ddd",
    padding: 6,
  },

  tableCell: {
    fontSize: 9,
    textAlign: "center",
  },

  tableHeaderText: {
    color: "#1e2a44",
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
  },

  hotelDetailCard: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#eee",
    borderRadius: 8,
    marginBottom: 8,
    overflow: "hidden",
    minHeight: 60,
  },
  hotelImage: {
    width: 85,
    height: "100%",
    objectFit: "cover",
  },
  hotelBody: {
    flex: 1,
    paddingVertical: 1,
    paddingHorizontal: 8,
    justifyContent: "center",
  },

  hotelName: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#2d0c57",
  },

  hotelMeta: { fontSize: 9, color: "#555", marginTop: 2 },

  mealRow: { flexDirection: "row", marginTop: 4 },

  mealBadge: {
    backgroundColor: "#e8f5e9",
    borderRadius: 4,
    paddingHorizontal: 6,
    paddingVertical: 2,
    marginRight: 4,
  },

  mealText: { fontSize: 8, color: "#2e7d32", fontWeight: "bold" },

  addonRow: {
    marginTop: 5,
  },

  addonTitle: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#2d0c57",
    marginBottom: 2,
  },

  addonText: {
    fontSize: 9,
    color: "#555",
    marginBottom: 1,
  },

  ferryRow: {
    backgroundColor: "#f4f6fb",
    borderRadius: 6,
    padding: 8,
    marginBottom: 6,
  },

  dayCard: {
    backgroundColor: "#f8f8ff",
    border: "1px solid #eee",
    padding: 10,
    borderRadius: 6,
    marginBottom: 8,
  },

  dayTitle: {
    fontSize: 11,
    fontWeight: "bold",
    color: "#2d0c57",
    marginBottom: 5,
  },
});

const Header = ({ logo, profile }) => (
  <View style={styles.header}>
    {logo && <Image
      src={{
        uri: logo,
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
        },
      }}
      style={styles.logo}
    />}
    <View>
      <Text style={styles.contact}>{profile?.organization?.mobileNumber}</Text>
      <Text style={styles.contact}>{profile?.organization?.email}</Text>
    </View>
  </View>
);

const PackagePDF = ({ data, profile }) => {

  const logo = profile?.organization?.logo;
  console.log(logo)
  const options = data?.options || [];

  const sortedDays = [...(data?.dayPlans || [])].sort(
    (a, b) => a.dayNumber - b.dayNumber,
  );

  const hasFerries =
    data.ferrys?.some((group) => (group.ferries || []).length > 0) || false;
  return (
    <Document>
      {/* COVER PAGE */}

      <Page size="A4" style={styles.page}>
        <Image
          src={bgImage}
          style={[styles.background, { objectFit: "cover" }]}
          fixed
        />
        <Header logo={logo} profile={profile} />

        <View style={styles.packageCard}>
          <Text style={styles.packageTitle}>{data.title}</Text>

          <Text style={styles.duration}>
            {data.durationNights} Nights/ {data.durationDays} Days
          </Text>

          <Text style={[styles.text, { textAlign: "center", marginTop: 8 }]}>
            Places: {data.places?.map((p) => p.name).join(" | ")}
          </Text>
        </View>
        <View style={styles.sectionCard}>
          <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>Vehicle Transfers</Text>
          </View>

          {options.slice(0, 1).map((option) => {
            const vehicles = data.vehicles?.filter(
              (v) => v.packageOption?._id === option._id,
            );

            if (!vehicles.length) return null;

            return (
              <View key={option._id} style={{ marginBottom: 8 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    color: "#2d0c57",
                    marginBottom: 4,
                  }}
                >
                  {option.name} Package
                </Text>

                {vehicles.map((v) => (
                  <Text key={v._id} style={styles.text}>
                    {v.vehicleType?.name} | Capacity {v.vehicleType?.capacity}
                  </Text>
                ))}
              </View>
            );
          })}
        </View>

        {/* FERRY TRANSFERS */}
        {hasFerries && (
          <View style={styles.sectionCard}>
            <View style={styles.sectionHeader}>
              <Text style={styles.sectionTitle}>Ferry Transfers</Text>
            </View>

            {options.slice(0, 1).map((option) => {
              const ferries = data.ferrys?.filter(
                (f) => f.packageOption?._id === option._id,
              );

              const allFerries = ferries.flatMap((f) => f.ferries || []);

              if (!allFerries.length) return null;

              return (
                <View key={option._id} style={{ marginBottom: 10 }}>
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "bold",
                      color: "#2d0c57",
                      marginBottom: 2,
                    }}
                  >
                    {option.name} Package
                  </Text>

                  {allFerries.map((fr) => (
                    <View key={fr._id} style={styles.ferryRow}>
                      <Text style={styles.text}>
                        {fr.fromPlace?.name} → {fr.toPlace?.name}
                      </Text>

                      <Text style={styles.text}>
                        {fr.ferry?.name} | {fr.className} | {fr.departureTime} -{" "}
                        {fr.arrivalTime}
                      </Text>
                    </View>
                  ))}
                </View>
              );
            })}
          </View>
        )}
        <View style={styles.sectionCard}>
          <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>Package Options</Text>
          </View>

          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              <View style={styles.tableCol}>
                <Text style={styles.tableHeaderText}>Option</Text>
              </View>

              <View style={styles.tableCol}>
                <Text style={styles.tableHeaderText}>Package</Text>
              </View>

              <View style={styles.tableCol}>
                <Text style={styles.tableHeaderText}>Per Person</Text>
              </View>

              <View style={styles.tableCol}>
                <Text style={styles.tableHeaderText}>Total</Text>
              </View>
            </View>

            {options.map((option, index) => (
              <View key={option._id} style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{index + 1}</Text>
                </View>

                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{option.name}</Text>
                </View>

                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Rs {option.sellingPricePerPerson}
                  </Text>
                </View>

                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Rs {option.sellingPricePerPerson * data.basePax}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </View>

      </Page>

      {/* HOTELS PER OPTION */}

      {options.map((option) => {
        const hotels =
          data.hotels?.filter(
            (h) => h.packageOption?._id === option._id,
          ) || [];

        if (hotels.length === 0) return null;

        return (
          <Page size="A4" style={styles.page} key={option._id}>
            <Image
              src={bgImage}
              style={[styles.background, { objectFit: "cover" }]}
              fixed
            />
            <Header logo={logo} profile={profile} />

            <View style={styles.sectionCard}>
              <View style={styles.sectionHeader}>
                <Text style={styles.sectionTitle}>Hotels - {option.name}</Text>
              </View>

              {hotels.map((h) => (
                <View key={h._id} style={styles.hotelDetailCard}>
                  <Image
                    src={{
                      uri: `${h.hotel?.image}?t=${Date.now()}`,
                    }}
                    style={styles.hotelImage}
                  />

                  <View style={styles.hotelBody}>
                    <Text style={styles.hotelName}>{h.hotel?.name}, {h.hotel?.location?.name}</Text>


                    <Text style={styles.hotelMeta}>
                      Room Type: {h.roomType?.name}
                    </Text>


                    <View style={styles.timeRow}>
                      <Text style={styles.hotelMeta}>
                        Check-in: {h.hotel?.checkInTime},
                      </Text>

                      <Text style={styles.hotelMeta}>
                        Check-out: {h.hotel?.checkOutTime}
                      </Text>
                    </View>

                    {getMeals(h.meals).length > 0 && (
                      <View style={styles.mealRow}>
                        {getMeals(h.meals).map((m) => (
                          <View key={m} style={styles.mealBadge}>
                            <Text style={styles.mealText}>{m}</Text>
                          </View>
                        ))}
                      </View>
                    )}
                    {Array.isArray(h.addons) && h.addons.length > 0 && (
                      <View style={styles.addonRow}>
                        <Text style={styles.addonTitle}>Hotel Add-ons:</Text>

                        {h.addons.map((addon, index) => (
                          <Text
                            key={addon._id || `${addon.name}-${index}`}
                            style={styles.addonText}
                          >
                            • {addon.name}
                          </Text>
                        ))}
                      </View>
                    )}
                  </View>
                </View>
              ))}
            </View>
          </Page>
        );
      })}



      <Page size="A4" style={styles.page}>
        <Image
          src={bgImage}
          style={[styles.background, { objectFit: "cover" }]}
          fixed
        />
        <Header logo={logo} profile={profile} />

        <View style={styles.sectionCard}>
          <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>Day Wise Itinerary</Text>
          </View>

          {sortedDays.map((day) => (
            <View key={day._id} style={styles.dayCard}>
              <Text style={styles.dayTitle}>
                Day {day.dayNumber} — {day.title}
              </Text>

              {parseListItems(day.description).map((p, i) => (
                <Text key={i} style={styles.text}>
                  {p}
                </Text>
              ))}



              {options.slice(0, 1).map((option) => {
                const actGroup = data.activities?.find(
                  (a) =>
                    a.dayPlan?._id === day._id &&
                    a.packageOption?._id === option._id,
                );

                if (!actGroup || !actGroup.activities?.length) return null;

                return (
                  <View key={option._id} style={{ marginTop: 6 }}>
                    <Text
                      style={{
                        fontSize: 10,
                        fontWeight: "bold",
                        color: "#2d0c57",
                        marginBottom: "3px"
                      }}
                    >
                      Activities
                    </Text>

                    {actGroup.activities.map((act, index) => (
                      <Text key={act._id || index} style={styles.text}>
                        • {act.activity?.name} | {act.timing}
                      </Text>
                    ))}
                  </View>
                );
              })}
            </View>
          ))}
        </View>
      </Page>

      {/* POLICIES */}

      <Page size="A4" style={styles.page}>
        <Image
          src={bgImage}
          style={[styles.background, { objectFit: "cover" }]}
          fixed
        />
        <Header logo={logo} profile={profile} />

        <View style={styles.sectionCard}>
          <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>Inclusions</Text>
          </View>
          <Text style={styles.text}>{stripHtml(data.inclusions)}</Text>
        </View>

        <View style={styles.sectionCard}>
          <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>Exclusions</Text>
          </View>
          <Text style={styles.text}>{stripHtml(data.exclusions)}</Text>
        </View>

        <View style={styles.sectionCard}>
          <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>Payment Policy</Text>
          </View>
          <Text style={styles.text}>{stripHtml(data.paymentpolicy)}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default PackagePDF;
